import { i18next } from '@yola/ws-sdk';
import lineHeightMap from '../../extensions/registry/ws-text-formatting/constants/line-height-map';

const getDefaultLineHeightOptions = (variable, basicLineHeightValues) => [
  { label: i18next.t('Auto'), value: 'Auto', defaultValue: basicLineHeightValues[variable] },
  ...Object.values(lineHeightMap).map((value) => ({
    value,
    label: value,
  })),
];

export default getDefaultLineHeightOptions;
